import {PlayerReduxState} from "../types";
import isRecognizing from "./isRecognizing";
import isErrorState from "./isErrorState";
import {getPreviousAction} from "./getPreviousAction";

export default function canGoBack(state: PlayerReduxState): boolean {
  if (isRecognizing(state) || isErrorState(state)) {
    return false;
  }

  const prevAction = getPreviousAction(state);

  return !(!prevAction);
}

